import actions from './actions'
import mutations from './mutations'

const notification = {
    namespaced: true,
    state: {
        filters: {
            sendTo: 'all',
            phones: ''
        },
        article: {
            title: '',
            body: '',
            shown: true
        },
        clients: [],
        result: {},
        count: 0,
        normalizePhones: null,
        isLoaded: false
    },
    mutations,
    actions
}

export default notification
